/**
 * Store some sustainability parameters in a persistent manner in app storage so that users can tweak the values as
 * needed to override the defaults.
 */
export default {
  state: {
    timeRange: undefined,
    startDate: undefined,
    endDate: undefined,
    currency: undefined,
    dieselPrice: undefined,
    dieselUnit: undefined,
    weightFormat: undefined,
    gallonsPerHour: undefined,
    dieselRuntimeTarget: undefined,
    stagingRuntimeTarget: undefined
  },

  getters: {
    timeRange: state => {
      return state.timeRange
    },

    startDate: state => {
      return state.startDate
    },

    endDate: state => {
      return state.endDate
    },

    currency: state => {
      return state.currency
    },

    dieselPrice: state => {
      return state.dieselPrice
    },

    dieselUnit: state => {
      return state.dieselUnit
    },

    weightFormat: state => {
      return state.weightFormat
    },

    gallonsPerHour: state => {
      return state.gallonsPerHour
    },

    dieselRuntimeTarget: state => {
      return state.dieselRuntimeTarget
    },

    stagingRuntimeTarget: state => {
      return state.stagingRuntimeTarget
    }
  },

  mutations: {
    setTimeRange (state, timeRange) {
      state.timeRange = timeRange
    },

    setStartDate (state, startDate) {
      state.startDate = startDate
    },

    setEndDate (state, endDate) {
      state.endDate = endDate
    },

    setCurrency (state, currency) {
      state.currency = currency
    },

    setDieselPrice (state, dieselPrice) {
      state.dieselPrice = dieselPrice
    },

    setDieselUnit (state, dieselUnit) {
      state.dieselUnit = dieselUnit
    },

    setWeightFormat (state, weightFormat) {
      state.weightFormat = weightFormat
    },

    setGallonsPerHour (state, gallonsPerHour) {
      state.gallonsPerHour = gallonsPerHour
    },

    setDieselRuntimeTarget (state, dieselRuntimeTarget) {
      state.dieselRuntimeTarget = dieselRuntimeTarget
    },

    setStagingRuntimeTarget (state, stagingRuntimeTarget) {
      state.stagingRuntimeTarget = stagingRuntimeTarget
    }
  },

  actions: {
    reset (context) {
      context.commit('setStartDate', undefined)
      context.commit('setEndDate', undefined)
      context.commit('setCurrency', undefined)
      context.commit('setDieselPrice', undefined)
      context.commit('setDieselUnit', undefined)
      context.commit('setWeightFormat', undefined)
      context.commit('setGallonsPerHour', undefined)
      context.commit('setDieselRuntimeTarget', undefined)
      context.commit('setStagingRuntimeTarget', undefined)
    },
    setTimeRange (context, timeRange) {
      context.commit('setTimeRange', timeRange)
    },
    setDateRange (context, startDate, endDate = null) {
      context.commit('setStartDate', startDate)
      context.commit('setEndDate', endDate)
    },
    setCurrency (context, currency) {
      context.commit('setCurrency', currency)
    },
    setDieselPrice (context, dieselPrice) {
      context.commit('setDieselPrice', dieselPrice)
    },
    setDieselUnit (context, dieselUnit) {
      context.commit('setDieselPrice', dieselUnit)
    },
    setWeightFormat (context, weightFormat) {
      context.commit('setWeightFormat', weightFormat)
    },
    setGallonsPerHour (context, gallonsPerHour) {
      context.commit('setGallonsPerHour', gallonsPerHour)
    },
    setDieselRuntimeTarget (context, dieselRuntimeTarget) {
      context.commit('setDieselRuntimeTarget', dieselRuntimeTarget)
    },
    setStagingRuntimeTarget (context, stagingRuntimeTarget) {
      context.commit('setStagingRuntimeTarget', stagingRuntimeTarget)
    }
  }
}
